import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//

import Vue from 'vue';
import filters from '@/utils/filters';
import Analytics from '@/utils/Analytics';
// globalMixin
import $ from 'zepto';
import Drip from 'drip';
import Toast from '@myfe/vue2-toast';
import '@myfe/vue2-toast/lib/toast.css';
require('@/common/global.mixin');
// vue 过滤器
Object.keys(filters).forEach(function (key, index) {
  Vue.filter(key, filters[key]);
});
Vue.use(Toast, {
  type: 'center',
  duration: 1500,
  wordWrap: true,
  width: 'auto'
});
export default {
  name: 'app',
  created: function created() {
    // 设置环境主题信息
    document.querySelector('body').setAttribute(this.themeName, '');
    $(document).off().on('click', '[data-href]', function (e) {
      Drip.redirect($(this).data('href'));
    });
  },
  computed: {
    themeName: function themeName() {
      var appType = this.Constant.appType;
      var themeNameMap = {
        1: '__dianping_theme__',
        2: '__meituan_theme__',
        3: '__dianping_theme__',
        5: '__maoyan_theme__',
        6: '__maoyan_theme__',
        13: '__maoyan_theme__',
        8: '__gewara_theme__',
        27: '__maoyan_theme__',
        28: '__maoyan_theme__'
      };
      return themeNameMap[appType];
    }
  }
};